import { render, staticRenderFns } from "./modalAgregarConjuntos.vue?vue&type=template&id=b50f4fc2&scoped=true"
import script from "./modalAgregarConjuntos.vue?vue&type=script&lang=js"
export * from "./modalAgregarConjuntos.vue?vue&type=script&lang=js"
import style0 from "./modalAgregarConjuntos.vue?vue&type=style&index=0&id=b50f4fc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50f4fc2",
  null
  
)

export default component.exports